var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _c("label", { staticClass: "font-size-12" }, [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      {
        staticClass: "icon-picker-wrap",
        attrs: { id: `icon-picker-wrap_${_vm.id}` },
      },
      [
        _c(
          "div",
          { staticClass: "icon-picker-wrapHeader" },
          [
            _vm.value
              ? [
                  _c(
                    "label",
                    {
                      attrs: { "data-id": _vm.id },
                      on: { click: _vm.toggleBox },
                    },
                    [_vm._v(_vm._s(_vm.value))]
                  ),
                  _c("i", {
                    class: _vm.xMarkIcon,
                    attrs: { "data-id": _vm.id },
                    on: { click: _vm.clearIcon },
                  }),
                ]
              : [
                  _c(
                    "label",
                    {
                      attrs: { "data-id": _vm.id },
                      on: { click: _vm.toggleBox },
                    },
                    [_c("i", { class: _vm.magnifyingIcon })]
                  ),
                ],
          ],
          2
        ),
        _vm.showBox
          ? _c("div", { staticClass: "icon-picker-modal" }, [
              _c(
                "div",
                {
                  staticClass: "icon-picker-modalHeader",
                  attrs: { "data-id": _vm.id },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Search icons...",
                      "data-id": _vm.id,
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.search = $event.target.value
                      },
                    },
                  }),
                ]
              ),
              _c(
                "ul",
                _vm._l(_vm.faIcons, function (icon, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      class: {
                        active:
                          !_vm.search ||
                          _vm.getIconName(icon).includes(_vm.search),
                      },
                      attrs: { "data-id": _vm.id },
                      on: {
                        click: function ($event) {
                          return _vm.clickIcon(icon)
                        },
                      },
                    },
                    [
                      _c("i", {
                        class: `fa ${_vm.getIconExtra(
                          icon
                        )} fa-${_vm.getIconName(icon)}`,
                        attrs: { title: icon },
                      }),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }